import React from "react";
import DayPickerContainer from "../../containers/DayPickerContainer";

const DateInput = ({
    id,
    type,
    className,
    onChange = () => {},
    placeholder,
    input,
    meta,
    disabledAfter
}) => (
    <DayPickerContainer
        id={id}
        placeholder={placeholder}
        value={input.value}
        onChange={(value) => {
            onChange(value);
            input.onChange(value);
        }}
        onBlur={input.onBlur}
        disabledAfter={disabledAfter}
    />
);
export default DateInput;
